/**
 * Landing page settings
 * @typedef {Object} LANDING_SETTINGS
 * @property {number} start_day
 * @property {number} start_month
 * @property {number} end_day
 * @property {number} end_month
 * @property {"image" | "video"} type
 * @property {string} path
 * @property {string} path_video
 */
/**
 * @type {LANDING_SETTINGS[]}
 */
export const LANDING_SETTINGS = [
  {
    start_day: 1,
    start_month: 3,
    end_day: 31,
    end_month: 5,
    type: "image",
    path: "landing/printemps.jpg",
    path_video: "landing/la_bresse_ete.mp4",
  },
  {
    start_day: 1,
    start_month: 6,
    end_day: 31,
    end_month: 8,
    type: "image",
    path: "landing/ete.jpg",
    path_video: "landing/la_bresse_ete.mp4",
  },
  {
    start_day: 1,
    start_month: 9,
    end_day: 30,
    end_month: 11,
    type: "image",
    path: "landing/automne.jpg",
    path_video: "landing/la_bresse_ete.mp4",
  },
  {
    start_day: 1,
    start_month: 12,
    end_day: 28,
    end_month: 2,
    type: "image",
    path: "landing/hiver.jpg",
    path_video: "landing/la_bresse_hiver.mp4",
  },
];

export const LANDING_FALLBACK = "landing/default.png";
